import { ImageSource } from 'expo-image';
import { registerImages } from '@bonanza-social/moonlight';
import images from './images';

registerImages('prizeWall', images);

declare global {
  interface RegisteredImages {
    prizeWall: Record<keyof typeof images, ImageSource>;
  }
}
